<template>
  <article :class="['notification', `is-${type}`]">
    <button
      type="button"
      aria-label="close notification"
      class="delete"
      @click="handleClose"
    ></button>
    <div class="media">
      <div class="media-left">
        <span
          class="icon is-large"
          aria-hidden=""
        >
          <i :class="['mdi', iconClass, 'mdi-48px']"></i>
        </span>
      </div>
      <div class="media-content">
        <slot>
          <p>{{ message }}</p>
        </slot>
      </div>
    </div>
  </article>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: (value) =>
      ['info', 'success', 'warning', 'danger'].includes(value)
  },
  message: {
    type: String,
    required: true
  }
});

const emit = defineEmits(['close']);

// Map types to icons
const typeIconMap = {
  info: 'fas fa-info-circle', // Info icon
  success: 'fas fa-check-square', // Success icon
  warning: 'fas fa-exclamation-triangle', // Warning icon
  danger: 'fas fa-ban' // Danger icon
};

// Compute the icon class based on type
const iconClass = computed(() => typeIconMap[props.type]);

const handleClose = () => {
  emit('close');
};
</script>

<style lang="scss" scoped>
.notification > .media {
  align-items: center;
  height: 3rem;
  width: 21rem;
}

article.notification {
  margin: 0;
}
</style>
